exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".privacy-policy[data-v-1477f0fe]{max-width:900px;margin:0 auto;font-family:Arial,sans-serif;line-height:1.6;font-size:14px}.text-center[data-v-1477f0fe]{text-align:center}.text-right[data-v-1477f0fe]{text-align:right}h5[data-v-1477f0fe]{margin-top:24px;margin-bottom:8px}ul[data-v-1477f0fe]{margin:8px 0 8px 20px}.document-body p[data-v-1477f0fe]{margin:8px 0}", ""]);

// exports
